/**
 * Глобальное состояние paywall-модалки (docs/billing/ui.md §2).
 *
 * Открывается из двух мест: UI-гейт (клик по видимой, но недоступной кнопке) и
 * глобальный перехват серверного 403 `{code: 'plan_limit'}` в `lib/api.ts` — поэтому
 * стор, а не локальный стейт: модалка одна на приложение, вызывающих много.
 */
import { create } from 'zustand';
import { requiredPlanForReason, type PaywallReason, type PlanId } from '@sloy/shared';

interface PaywallState {
  reason: PaywallReason | null;
  /** Какой план предлагать в CTA. Сервер знает точнее (учитывает текущий план). */
  requiredPlan: PlanId;
  /**
   * Чей тариф не потянул. Карта может лежать не в активном воркспейсе, и без этого
   * CTA уводил бы оплачивать совсем не тот (docs/billing/ui.md §2).
   */
  workspaceId: string | null;
  open: (reason: PaywallReason, requiredPlan?: PlanId, workspaceId?: string | null) => void;
  close: () => void;
}

export const usePaywallStore = create<PaywallState>((set) => ({
  reason: null,
  requiredPlan: 'pro',
  workspaceId: null,
  open: (reason, requiredPlan, workspaceId) =>
    set({
      reason,
      requiredPlan: requiredPlan ?? requiredPlanForReason(reason, 'free'),
      workspaceId: workspaceId ?? null,
    }),
  close: () => set({ reason: null }),
}));
